<template>
    <div class="card-wrapper mb-4">
        <component :is="isMuted ? 'div' : 'a'" :href="shouldGoToUri" class="card course h-100 w-100" :class="{
            'featured': (highlightFeatured && vodCourse.is_featured),
            'muted': isMuted
        }">
            <div class="card-body d-flex flex-column justify-content-between">
                <div>
                    <div v-if="showComingSoonTag && this.vodCourse.isPreregCourse" class="label">COMING SOON</div>
                    <div class="text-center img-wrap">
                        <img class="card-img-top-virtuoso h-auto" :src="vodCourse.imageUris ? vodCourse.imageUris.cardThumb.url : ''"
                             :alt="vodCourse.name"
                             loading="lazy"
                             width="320"
                             height="180">

                        <template v-if="vodCourse.progress">
                            <div class="progress">
                                <div class="progress-bar" role="progressbar" :style="'width:'+ progressPercentage +'%;'"></div>
                            </div>
                        </template>
                    </div>

                    <template v-if="vodCourse.teachers">
                        <template v-if="vodCourse.teachers.length > 0">
                            <div class="teacher-list grey-subtitle">{{ vodCourse.teachers[0].name }}</div>
                        </template>
                    </template>

                    <h2 class="card-title">{{ vodCourse.name }}</h2>
                    <div class="genres mb-2" v-if="vodCourse.genresFormatted" v-html="vodCourse.genresFormatted"></div>
                    <p class="black-text" v-if="vodCourse.experienceLevelsFormatted">
                        Levels: {{ vodCourse.experienceLevelsFormatted }}
                    </p>
                </div>

                <div>
                    <p :class="{'mb-0': !vodCourse.partner}">
                        {{ vodCourse.formattedPrice }}
                    </p>

                    <div class="mt-auto" v-if="vodCourse.partner">
                        <img :src="vodCourse.partner.imageUris ? vodCourse.partner.imageUris.cardPartner.url : ''" class="partner-logo">
                    </div>
                </div>
            </div>
        </component>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: Number,
            default: null
        },
        vodCourseData: {
            type: Object,
            default: null
        },
        highlightFeatured: {
            type: Boolean,
            default: true
        },
        isHomePage: {
            type: Boolean,
            default: false
        },
        showComingSoonTag: {
            type: Boolean,
            default: false
        },
        muted: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            vodCourse: {},
            isSubscribed: false,
            progressPercentage: 0,
            isMuted: false,
        }
    },

    computed: {
        shouldGoToUri: function () {
            if(this.vodCourse.isUserEnrolled) {
                return this.vodCourse.classroomUri;
            } else {
                return this.vodCourse.uri;
            }
        }
    },

    mounted() {
        // User logged in?
        if(window.virtuoso) {
            this.isSubscribed = window.virtuoso.is_subscribed;
        }

        if(this.vodCourseData) {
            this.vodCourse = this.vodCourseData;
        } else {
            this.getCourse();
        }

        if(this.vodCourse.progress) {
            this.progressPercentage = (this.vodCourse.progress.current/this.vodCourse.progress.total)*100;
        }

        if(this.vodCourse.isPreregCourse == true) {
            this.isMuted = true;
        }

        // Prop option
        if(this.muted == true) {
            this.isMuted = true;
        }

        console.log(this.vodCourse.name, this.vodCourse.partner);
    },

    methods: {
        getCourse: function() {
            axios.get('/api/vod_courses/' + this.id)
                .then((response) => {
                    this.vodCourse = response.data;
                });
        }
    }
}
</script>
